import { InputEmployeeGroupController } from "../../controllers";

import { InputEnum } from "./InputEnum";

/**
 * Select an employee group.
 * @example
 * ```html
 * <salaxy-input-employee-group ng-model="employeeGroup" type="select"  name="EmployeeGroup"  label="Employee Group"></salaxy-input-employee-group>
 * ```
 */
export class InputEmployeeGroup extends InputEnum {

    constructor() {
      super();
      /** Uses the InputEmployeeGroupController */
      this.controller = InputEmployeeGroupController as any;
    }
}
